import { Mutation } from "@apollo/client/react/components";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Toasts } from "@selfdetermine/react-toasts";
import { ActionButton } from "../../../components";
import { ui } from "../../../Constants";
import { MutationSubmit } from "../../../Utils";

import { PERSON } from "../graphql";

import { DELETE_BLOOD_QUANTUM } from "./graphql";

class DeleteBloodQuantumModalForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  _toggleModal = () => {
    this.setState((prevState) => {
      const updated = !prevState.modal;

      return { modal: updated };
    });
  };

  render() {
    const { person, bloodQuantum, children, right } = this.props;

    return (
      <>
        <ActionButton
          onClick={this._toggleModal}
          className={`btn-secondary ${right ? "float-right" : ""}`}
          size="sm"
        >
          {children || <>{ui.icon.plus} New</>}
        </ActionButton>
        <Modal
          isOpen={this.state.modal}
          toggle={this._toggleModal}
          className={this.props.classNam}
          size="sm"
        >
          <ModalHeader toggle={this._toggleModal}>
            Remove Blood Quantum
          </ModalHeader>
          <ModalBody>Are you sure you want to remove?</ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this._toggleModal}>
              Cancel
            </Button>
            <Mutation
              mutation={DELETE_BLOOD_QUANTUM}
              onCompleted={() => {
                Toasts.add("Blood quantum deleted");
                this._toggleModal();
              }}
              onError={(error) =>
                Toasts.danger("Unable to remove blood quantum", error)
              }
              variables={{
                person: person.id,
                bloodQuantum: bloodQuantum.id,
              }}
              refetchQueries={[
                {
                  query: PERSON.BLOOD_QUANTA_QUERY,
                  variables: { person: person.id },
                },
              ]}
            >
              {(callMutation, { loading }) => (
                <MutationSubmit
                  color="danger"
                  label="Confirm"
                  loadingLabel="Deleting..."
                  onClick={callMutation}
                  loading={loading}
                />
              )}
            </Mutation>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

DeleteBloodQuantumModalForm.propTypes = {
  bloodQuantum: PropTypes.shape.isRequired,
};

DeleteBloodQuantumModalForm.defaultProps = {};

export default DeleteBloodQuantumModalForm;
